'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TwoFactorAuthId$() {
  this.cd2 = null;
  this.cd3 = false;
  this.cd0 = null;
  this.cd1 = false;
}
export { $c_Lpresto_types$TwoFactorAuthId$ as $c_Lpresto_types$TwoFactorAuthId$ };
$p = $c_Lpresto_types$TwoFactorAuthId$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TwoFactorAuthId$;
/** @constructor */
function $h_Lpresto_types$TwoFactorAuthId$() {
}
export { $h_Lpresto_types$TwoFactorAuthId$ as $h_Lpresto_types$TwoFactorAuthId$ };
$h_Lpresto_types$TwoFactorAuthId$.prototype = $p;
$p.vn = (function() {
  if ((!this.cd3)) {
    this.cd2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j9;
    this.cd3 = true;
  }
  return this.cd2;
});
$p.zs = (function() {
  if ((!this.cd1)) {
    this.cd0 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().e1;
    this.cd1 = true;
  }
  return this.cd0;
});
var $d_Lpresto_types$TwoFactorAuthId$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TwoFactorAuthId$, "presto.types$TwoFactorAuthId$", ({
  a2p: 1,
  D: 1
}));
export { $d_Lpresto_types$TwoFactorAuthId$ as $d_Lpresto_types$TwoFactorAuthId$ };
var $n_Lpresto_types$TwoFactorAuthId$;
function $m_Lpresto_types$TwoFactorAuthId$() {
  if ((!$n_Lpresto_types$TwoFactorAuthId$)) {
    $n_Lpresto_types$TwoFactorAuthId$ = new $c_Lpresto_types$TwoFactorAuthId$();
  }
  return $n_Lpresto_types$TwoFactorAuthId$;
}
export { $m_Lpresto_types$TwoFactorAuthId$ as $m_Lpresto_types$TwoFactorAuthId$ };
//# sourceMappingURL=presto.types$-Two-Factor-Auth-Id$.js.map
